import { createReducer } from '../store.model';

import {
    ActionType,
    Reload,
    ReloadResult,
    RepCardAction,
    RootClearStateAction,
    SortByColumn,
} from './coaching-card-rep.action';
import { CoachingCardRepState, defaultState } from './coaching-card-rep.state';
import { actionHandler } from './functions/card-actions-handler.function';
import { cardDataTransformer } from './functions/rep-card-data.transformer.function';
import { compare } from './helper/sortable-table-header.directive';
const { builder, reducer } = createReducer<ActionType, CoachingCardRepState>(
    defaultState(),
);

builder
    .add<Reload>(ActionType.COACHING_CARD_REP__ROOT__RELOAD, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: true,
                hasData: true,
            },
        };
    })

    .add<ReloadResult>(
        ActionType.COACHING_CARD_REP__ROOT__RELOAD_RESULT,
        (state, action) => {
            const card = action.payload.card;
            if (card == null) {
                return {
                    ...state,
                    pending: {
                        ...state.pending,
                        reload: false,
                        hasData: false,
                    },
                };
            }
            const dataset = cardDataTransformer(card);

            return {
                ...state,
                pending: {
                    ...state.pending,
                    reload: false,
                    hasData: true,
                },
                dataset,
            };
        },
    );

builder.add<SortByColumn>(
    ActionType.COACHING_CARD_REP__ROOT__SORT_BY_COLUMN,
    (state, action) => {
        const data = state.dataset;
        const index = action.payload.index;
        const column = action.payload.column;
        const direction = action.payload.direction;

        data[index].childItems = data[index].childItems.sort((a, b) => {
            const res = compare(
                a.opportunityItem[column],
                b.opportunityItem[column],
            );
            return direction === 'asc' ? res : -res;
        });
        return {
            ...state,
            dataset: data,
        };
    },
);

builder.add<RepCardAction>(
    ActionType.COACHING_CARD_REP__ROOT__REP_CARD_ACTIONS,
    (state, action) => {
        const dataset = actionHandler(
            state.dataset,
            action.payload.actionType,
            action.payload.index,
        );
        return {
            ...state,
            dataset,
        };
    },
);

builder.add<RootClearStateAction>(
    ActionType.COACHING_CARD_REP_ROOT__CLEAR_STATE,
    () => {
        return defaultState();
    },
);

export const coachingCardRepReducer = reducer;
